/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamQuestionLibraryQueryResponse,
  GetApiV1ExamQuestionLibraryQueryParams,
  GetApiV1ExamQuestionLibrary400,
  GetApiV1ExamQuestionLibrary401,
  GetApiV1ExamQuestionLibrary500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibrary.ts";

function getGetApiV1ExamQuestionLibraryUrl() {
  const res = { method: "GET", url: `/api/v1/exam/question-library` as const };
  return res;
}

/**
 * @description Retorna a lista paginada de questões da biblioteca de questões, aplicando filtros de data, disciplina, autor, empresa, tipo de componente, idioma, status e texto. **(Requer Authorization para autenticação)**
 * @summary Listar questões da biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library}
 */
export async function getApiV1ExamQuestionLibrary(
  params?: GetApiV1ExamQuestionLibraryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamQuestionLibraryQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamQuestionLibrary400
      | GetApiV1ExamQuestionLibrary401
      | GetApiV1ExamQuestionLibrary500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamQuestionLibraryUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
